import {ApmBase, init as initApm, Span} from '@elastic/apm-rum'

class Apm{
    static span_list: Span[] = [];
    static context: ApmBase|undefined = undefined;

    static init(): void{
        if(!Apm.context){
            Apm.context = initApm({
                serviceName: 'reactjs-arqt-assine-3',
                serverUrl: 'https://0967f57e07d34531a9c63c9cac695992.apm.us-east1.gcp.elastic-cloud.com:443',
                environment: process.env.NEXT_PUBLIC_ELASTIC_APM_ENVIRONMENT ?? process.env.ELASTIC_APM_ENVIRONMENT ?? process.env.NODE_ENV ?? process.env.APP_ENV ?? "production",
                breakdownMetrics: true,
                centralConfig: false,
                // Permite que o RUM injete traceparent/tracestate nas chamadas pro middleware,
                // conectando a transaction do browser na mesma trace do middleware/backend.
                distributedTracingOrigins: [process.env.NEXT_PUBLIC_API_URL || 'https://assine3-be.estadao.com.br/']
            })
        }
    }

    static startTransactionEvent(key: string, context_custom: {[key: string]: string|number|boolean }): void{

        if(Apm?.context){
            try {
                let tr = Apm?.context.startTransaction(`Event - ${key}`, "event", {
                    managed: true,
                    canReuse: true,
                    //@ts-ignore
                    reuseThreshold: 300
                });

                if (tr && context_custom) {
                    tr.addContext({
                        custom: context_custom
                    });
                }

                if (tr) {
                    tr.addLabels({
                        [key]: "1"
                    });
                }
            }catch (e){
                //
            }

        }

    }

    static captureError(error: Error | string): void{
        if(Apm.context)
            Apm.context?.captureError(error);
    }

    static setUserContext(user: UserObject): void{
        if(Apm.context)
            Apm.context?.setUserContext(user);
    }

    static addLabels(labels: Labels): void{
        if(Apm.context)
            Apm.context?.addLabels(labels);
    }
}

export default Apm
